import { Component, Inject, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DataManagerService } from '../../data/services/DataManager/data-manager.service';
import { ApiErrorModel } from '../../data/model/ApiErrorModel/api-error.model';
import { AppConstants } from '../../shared/constants/app-constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {PasswordResetAction} from './password-reset.action';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css'],
    standalone: false
})
export class PasswordResetComponent extends PasswordResetAction implements OnInit {
  email: string;
  token: string;
  password: string;
  password_confirmation: string;
  topErrorMessage: string;
  keys: string[];
  keys1: string[];
  reset: string;

  constructor(router: Router, route: ActivatedRoute, dataManager: DataManagerService, snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject('LOCALSTORAGE') private localStorage: any) {
    super();
    this.route = route;
    this.snackBar = snackBar;
    this.reset = '/reset-password';
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] ?? this.localStorage.getItem('email');
      this.token = params['token'] ?? this.localStorage.getItem('token');
    });
    this._resetPassword = AppConstants.BASE_URL + this.reset;
    this.router = router;
    this.dataManager = dataManager;
  }

  ngOnInit() {
  }

  resetpass(): void {
    this.loadFlag = true;
    const postBody = {};
    postBody['email'] = this.email;
    postBody['token'] = this.token;
    postBody['password'] = this.password;
    postBody['password_confirmation'] = this.password_confirmation;
    this.resetPassword(postBody);
  }

  back() {
    this.routeNavigate('/signin');
  }
  redirectToRegister() {
    this.routeNavigate('/register');
  }

  protected passForgotPasswordResponse(res: any) {
    this.snackBar.open(
      'Password sent to your mail id successfully',
      'OK',
      {
        duration: 30000,
        panelClass: 'success-snack'
      });
    this.routeNavigate('/signin');
  }

  protected passForgotPasswordError(error: ApiErrorModel) {
    this.showSnackBar(error.message, 'Registration Error', 30000);
    this.loadFlag = false;
    this.errorMsg = error.message;
    this.topErrorMessage = error.errors;
    this.keys = Object.keys(this.topErrorMessage);
    this.keys1 = Object.values(this.topErrorMessage);
    let i: number;
    let j: number;
    const name = ['password_confirmation', 'password'];
    for (i = 0; i < this.keys.length; i++) {
      for (j = 0; j < name.length; j++) {
        if (this.keys[i].match(name[j])) {
          document.getElementById(name[j]).style.borderColor = '#a94442';
          document.getElementById(name[j] + 1).style.display = 'block';
        }
      }
    }
  }
  onKeydown(event) {
    if (event.key === 'Enter') {
      console.log(event);
      this.resetpass();
    }
  }
}
